import React from 'react';
import NavigationBar from "./NavigationBar";

const Body = ({ children }) => {
    return (
        <div className={"app-container"}>
            <div className="nav-container">
                <NavigationBar />
            </div>
            <div className="content-container">
                {children}
            </div>
        </div>
    );
}

export default Body;